import { formatText } from "../pushNotificationMessage";

const messages = async ({ actionType, notifyContent }) => {

    const message = {
        newEnquiry: {
            title: `استفسار جديد`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        declined: {
            title: `انخفض`,
            message: `${formatText(notifyContent['userName'])}: تم رفض الحجز`
        },
        approved: {
            title: `موافقة`,
            message: `${formatText(notifyContent['userName'])}: تمت الموافقة على الحجز`
        },
        newMessage: {
            title: `رسالة جديدة`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        cancelReservation: {
            title: `تم إلغاء الحجز`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        newBooking: {
            title: `حجز جديد`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        preApprove: {
            title: `حجز جديد`,
            message: `${formatText(notifyContent['userName'])}: تمت الموافقة على طلبك مسبقًا`
        },
        listApproved: {
            title: `لقد قام المسؤول بالتحقق من قائمتك`,
            message: `${formatText(notifyContent['userName'])} : لقد قام المسؤول بالتحقق من قائمتك ${notifyContent['listTitle']} . يرجى نشر قائمتك للحصول على الحجوزات.`
        },
        listDeclined: {
            title: `لقد رفض المسؤول إدراجك`,
            message: `${formatText(notifyContent['userName'])} : لقد رفض المسؤول طلبك لإدراج ${notifyContent['listTitle']} بسبب ${notifyContent['reason']}. يُرجى تحديث معلومات الإدراج وإرسالها للموافقة على الإدراج.`
        },
        noHostPayout: {
            title: `تفاصيل الدفع مفقودة`,
            message: `${formatText(notifyContent['userName'])}:تحديث! يُرجى تحديث معلومات الدفع لتلقي مدفوعات الحجز.`
        },
        approvedDocument: {
            title: `تمت الموافقة على الوثيقة!`,
            message: `لقد تمت الموافقة على مستندك بنجاح.`
        },
        rejectDocument: {
            title: `تم رفض الوثيقة!`,
            message: `تم رفض مستندك المُرسل من قِبل الإدارة. يُرجى التواصل مع الإدارة لمزيد من المعلومات.`
        }
    }

    return message[actionType]
}
export default messages;